<template>
  <div>
    <h5 class="mb-3" v-if="!egress_profile_id">
      {{
        $t("curricularProducts.competence.associateToProfile", {
          entity1: $getVisibleNames("mesh.competence", false, "Competencia"),
          entity2: $getVisibleNames(
            "mesh.egressprofile",
            false,
            "Perfil de Egreso"
          ),
        })
      }}
    </h5>
    <h6 class="mb-3" v-else>
      {{
        $t("curricularProducts.competence.definePositionInProfile", {
          entity1: $getVisibleNames("mesh.competence", false, "Competencia"),
          entity2: $getVisibleNames(
            "mesh.egressprofile",
            false,
            "Perfil de Egreso"
          ),
        })
      }}
    </h6>
    <div
      v-if="isNaN(egress_profile_id)"
      v-can="'mesh.add_egressprofilecompetence'"
      class="d-flex justify-content-end mb-2"
    >
      <ButtonMedium
        :text_button="
          $t('curricularProducts.competence.linkToAll', {
            count: pendingBulkLinkRows.length,
          })
        "
        :tooltip_text="bulkLinkTooltip"
        :click_button="askBulkLink"
        :variant="'primary'"
        :icon="'plus'"
        :disabled_button="!competenceExists || pendingBulkLinkRows.length == 0"
        :loading="bulk_linking"
      ></ButtonMedium>
    </div>
    <!-- <div class="search-competence" v-if="!egress_profile_id">
      <b-input-group size="sm">
        <b-input-group-prepend is-text>
          <b-icon icon="search"></b-icon>
        </b-input-group-prepend>
        <b-form-input
          id="search-form"
          type="search"
          v-model="input_search"
          placeholder="Buscar..."
        >
        </b-form-input>
      </b-input-group>
    </div> -->
    <GenericBTable
      :items="profile_competences_list"
      :fields="fields"
      :filterCustom="filterCustom"
      :show_pagination="true"
      :search_filter="true"
      :selection_mode="true"
      :columns_display="true"
      :display_id="Competence.id"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      @emitChangeSearchField="changeInputSearch"
    >
      <template #cell(career)="row">
        {{ getCareer(row.item.egress_profile) }}
      </template>
      <template #cell(professional_title)="row">
        <template v-if="getEgressProfile(row.item.egress_profile)">
          {{ getEgressProfile(row.item.egress_profile).professional_title }}
        </template>
      </template>
      <template #cell(academic_degree)="row">
        <template v-if="getEgressProfile(row.item.egress_profile)">
          {{ getEgressProfile(row.item.egress_profile).academic_degree }}
        </template>
      </template>
      <template #cell(cycle)="row">
        <template>
          <CycleEgressProfileCompetence
            :cycle_id="cycle_id"
            :egress_profile_id="row.item.egress_profile"
            :can_edit_cycle="can_edit_cycle"
            :egress_profile_competence_id="row.item.id"
            :disabled="!row.item.selected"
            @updated="slotCycleUpdated"
          ></CycleEgressProfileCompetence>
        </template>
      </template>
      <template #cell(order)="row">
        <b-form-input
          type="number"
          class="sm m-0 py-0"
          v-model="row.item.order"
          min="1"
          @change="slotProfilesSelectionChanged"
          :state="orderState(row.item)"
          v-b-tooltip.left.v-secondary.noninteractive="
            !orderState(row.item)
              ? $t('curricularProducts.competence.orderTooltip', {
                  entity: $getVisibleNames(
                    'mesh.competence',
                    false,
                    'Competencia'
                  ),
                })
              : ''
          "
          :disabled="!row.item.selected || !can_edit_order"
        >
        </b-form-input>
      </template>
      <template #cell(selected)="row">
        <b-form-checkbox
          v-model="row.item.selected"
          @input="(value) => slotSelectionChanged(value, row.item)"
          class="check-profile-competence"
          :disabled="!isNaN(egress_profile_id)"
        >
        </b-form-checkbox>
      </template>
    </GenericBTable>
  </div>
</template>
<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { generateUniqueId, toast } from "@/utils/utils";

export default {
  name: "EgressProfileCompetence",
  components: {
    CycleEgressProfileCompetence: () =>
      import("@/components/reusable/CycleEgressProfileCompetence.vue"),
    GenericBTable: () => import("@/components/reusable/GenericBTable.vue"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
  },
  props: {
    Competence: {
      type: Object,
    },
    egress_profile_id: {
      type: Number,
    },
    cycle_id: {
      type: Number,
    },
    order: {
      type: Number,
    },
    can_edit_order: {
      type: Boolean,
      default: true,
    },
    can_edit_cycle: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      profile_competences_list: [],
      check_selected: [],
      selected_cycle: null,
      is_checked: false,
      input_search: "",
      sortBy: "",
      sortDesc: false,
      bulk_linking: false,
      // Orden y ciclo guardados de cada vínculo, para no actualizar los que no cambian
      persisted_values: {},
    };
  },
  computed: {
    ...mapGetters({
      institution: "getInstitution",
      cycles: names.CYCLES,
      storedCompetences: names.COMPETENCES,
      egressProfiles: names.EGRESS_PROFILES,
      careers: names.CAREERS,
      profileCompetences: names.PROFILE_COMPETENCES,
    }),
    competenceExists() {
      return this.Competence && !isNaN(this.Competence.id);
    },
    pendingBulkLinkRows() {
      // Filas sin vínculo guardado, de perfiles abiertos, que pasan la búsqueda
      return this.profile_competences_list.filter(
        (row) =>
          isNaN(row.id) &&
          !this.getEgressProfile(row.egress_profile).is_closed &&
          (!this.input_search || this.filterCustom(row))
      );
    },
    bulkLinkTooltip() {
      const entities = {
        competence: this.$getVisibleNames(
          "mesh.competence",
          false,
          "Competencia"
        ),
        profiles: this.$getVisibleNames(
          "mesh.egressprofile",
          true,
          "Perfiles de Egreso"
        ),
      };
      return this.competenceExists
        ? this.$t("curricularProducts.competence.linkToAllTooltip", entities)
        : this.$t("curricularProducts.competence.linkToAllSaveFirst", entities);
    },
    fields() {
      return [
        {
          key: "selected",
          label: "",
          thStyle: { width: "min-content" },
          display_column: true,
        },
        {
          key: "career",
          label: String(
            this.$getVisibleNames("mesh.career", false, "Programa")
          ),
          thStyle: { font: "font-weight-bold" },
          sortable: true,
          // El item no tiene career: la celda lo resuelve desde el perfil de egreso
          sortByFormatted: (value, key, item) => this.getCareer(item.egress_profile),
          display_column: true,
        },
        {
          key: "professional_title",
          label: String(
            this.$getVisibleNames(
              "manual.mesh.titulo_profesional",
              false,
              "Título Profesional"
            )
          ),
          sortable: true,
          // El item no tiene professional_title: sale del perfil de egreso
          sortByFormatted: (value, key, item) =>
            this.getEgressProfile(item.egress_profile).professional_title || "",
          display_column: true,
        },
        !(
          this.institution.internal_use_id == "duoc.cl" ||
          !this.institution.show_academic_degree
        )
          ? {
              key: "academic_degree",
              label: String(
                this.$getVisibleNames(
                  "manual.grado_academico",
                  false,
                  "Grado Académico"
                )
              ),
              sortable: true,
              // El item no tiene academic_degree: sale del perfil de egreso
              sortByFormatted: (value, key, item) =>
                this.getEgressProfile(item.egress_profile).academic_degree || "",
              display_column: true,
            }
          : { key: "academic_degree", label: "", display_column: false },
        !(this.institution.internal_use_id == "duoc.cl")
          ? {
              key: "cycle",
              label: this.$getVisibleNames(
                "mesh.cycle",
                false,
                "Ciclo Formativo"
              ),
              thStyle: { width: "18%" },
              requires_check_selected: true,
              sortable: true,
              display_column: true,
            }
          : { key: "cycle", label: "", display_column: false },
        {
          key: "order",
          label: this.$t("reusable.common.order"),
          thStyle: { width: "12%" },
          requires_check_selected: true,
          sortable: true,
          display_column: true,
        },
      ];
    },
  },
  methods: {
    orderState(item) {
      if (item.egress_profile) {
        const profile_competence = this.profileCompetences.filter(
          (x) =>
            x.egress_profile == item.egress_profile &&
            x.order == item.order &&
            x.cycle == item.cycle
        );
        if (
          profile_competence.length > 1 ||
          (profile_competence.length > 0 && isNaN(item.id))
        ) {
          return false;
        }
      }
      return true;
    },
    filterCustom(row) {
      if (
        this.$filtered(this.getCareer(row.egress_profile), this.input_search) ||
        this.$filtered(
          this.getEgressProfile(row.egress_profile).professional_title,
          this.input_search
        ) ||
        this.$filtered(
          this.getEgressProfile(row.egress_profile).academic_degree,
          this.input_search
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    changeInputSearch(input_search) {
      this.input_search = input_search;
    },
    fetchEgressprofileCompetences() {
      this.profile_competences_list = [];
      // isNaN(id) indica que es un ID temporal (string de generateUniqueId), no existe en BD
      const competence_exists =
        this.Competence && !isNaN(this.Competence.id);
      if (!isNaN(this.egress_profile_id)) {
        // Caso 1: perfil de egreso específico
        if (competence_exists) {
          // Competencia ya guardada — pedir solo el registro exacto
          this.$store
            .dispatch(names.FETCH_PROFILE_COMPETENCES, {
              competence_id: this.Competence.id,
              egress_profile_id: this.egress_profile_id,
            })
            .then((profile_competences) => {
              const profile_competence = profile_competences.find(
                (x) =>
                  x.competence == this.Competence.id &&
                  x.egress_profile == this.egress_profile_id
              );
              if (profile_competence) {
                profile_competence.selected = true;
                this.persistValues(profile_competence);
                this.profile_competences_list.push(profile_competence);
              } else {
                this.profile_competences_list.push({
                  id: generateUniqueId(),
                  egress_profile: this.egress_profile_id,
                  cycle: null,
                  order: this.order ? this.order : 1,
                  competence: this.Competence.id,
                  selected: true,
                });
              }
            });
        } else {
          // Competencia nueva — aún no existe en BD, no hay profile_competences
          this.profile_competences_list.push({
            id: generateUniqueId(),
            egress_profile: this.egress_profile_id,
            cycle: null,
            order: this.order ? this.order : 1,
            competence: this.Competence ? this.Competence.id : null,
            selected: true,
          });
        }
      } else {
        // Caso 2: sin perfil específico — tabla con todos los perfiles
        if (competence_exists) {
          // Competencia ya guardada — pedir profile_competences de esta competencia + todos los perfiles en paralelo
          Promise.all([
            this.$store.dispatch(names.FETCH_PROFILE_COMPETENCES, {
              competence_id: this.Competence.id,
            }),
            this.$store.dispatch(names.FETCH_EGRESS_PROFILES),
          ]).then(([profile_competences, egress_profiles]) => {
            egress_profiles.forEach((egress_profile) => {
              const profile_competence = profile_competences.find(
                (x) =>
                  x.competence == this.Competence.id &&
                  x.egress_profile == egress_profile.id
              );
              if (profile_competence) {
                profile_competence.selected = true;
                this.persistValues(profile_competence);
                this.profile_competences_list.push(profile_competence);
              } else {
                this.profile_competences_list.push({
                  id: generateUniqueId(),
                  egress_profile: egress_profile.id,
                  cycle: null,
                  order: this.order ? this.order : 1,
                  competence: this.Competence.id,
                  selected: false,
                });
              }
            });
          });
        } else {
          // Competencia nueva — solo pedir egress_profiles para mostrar la tabla vacía
          this.$store
            .dispatch(names.FETCH_EGRESS_PROFILES)
            .then((egress_profiles) => {
              egress_profiles.forEach((egress_profile) => {
                this.profile_competences_list.push({
                  id: generateUniqueId(),
                  egress_profile: egress_profile.id,
                  cycle: null,
                  order: this.order ? this.order : 1,
                  competence: this.Competence ? this.Competence.id : null,
                  selected: false,
                });
              });
            });
        }
      }
    },
    getEgressProfile(egress_profile) {
      let get_egress_profile = this.egressProfiles.find(
        (x) => x.id == egress_profile
      );
      return get_egress_profile ? get_egress_profile : [];
    },
    getCareer(egress_profile) {
      let get_career = this.careers.find((x) =>
        x.egress_profiles.includes(egress_profile)
      );
      return get_career ? get_career.name : "";
    },
    cyclesToSelect(egress_id) {
      return [
        {
          id: null,
          name: this.$t("reusable.common.notApplicable"),
        },
      ].concat(
        this.cycles.filter((cycle) => cycle.egress_profiles.includes(egress_id))
      );
    },
    slotProfilesSelectionChanged() {
      // Emite la señal updated junto a todas las instancias de Egressprofile_Competence.
      // Las seleccionadas y las que no.
      this.$emit(
        "updated",
        this.profile_competences_list,
        this.persisted_values
      );
    },
    persistValues(profile_competence) {
      this.persisted_values[profile_competence.id] = {
        order: profile_competence.order,
        cycle: profile_competence.cycle,
      };
    },
    askBulkLink() {
      const rows = this.pendingBulkLinkRows;
      this.$swal({
        title: this.$t("curricularProducts.competence.linkToAllConfirmTitle", {
          competence: this.$getVisibleNames(
            "mesh.competence",
            false,
            "Competencia"
          ),
          count: rows.length,
          profiles: this.$getVisibleNames(
            "mesh.egressprofile",
            rows.length != 1,
            rows.length != 1 ? "Perfiles de Egreso" : "Perfil de Egreso"
          ),
        }),
        text: this.$t("curricularProducts.competence.linkToAllConfirmText", {
          profile: this.$getVisibleNames(
            "mesh.egressprofile",
            false,
            "Perfil de Egreso"
          ),
        }),
        type: "question",
        showCancelButton: true,
        confirmButtonText: this.$t(
          "curricularProducts.competence.linkToAllConfirmButton"
        ),
        cancelButtonText: this.$t("reusable.common.cancel"),
      }).then((result) => {
        if (result.value) this.bulkLink(rows);
      });
    },
    bulkLink(rows) {
      // Sin orden, el servidor deja cada vínculo al final de su ciclo en el perfil
      this.bulk_linking = true;
      this.$store
        .dispatch(names.BULK_LINK_PROFILE_COMPETENCES, {
          competence: this.Competence.id,
          links: rows.map((row) => ({
            egress_profile: row.egress_profile,
            cycle: row.cycle,
            order: row.selected ? row.order || null : null,
          })),
        })
        .then((response) => {
          this.replaceRowsWithLinks(response.created.concat(response.existing));
          toast(
            this.$t("curricularProducts.competence.linkedToProfiles", {
              competence: this.$getVisibleNames(
                "mesh.competence",
                false,
                "Competencia"
              ),
              count: response.created.length,
              profiles: this.$getVisibleNames(
                "mesh.egressprofile",
                response.created.length != 1,
                response.created.length != 1
                  ? "Perfiles de Egreso"
                  : "Perfil de Egreso"
              ),
            })
          );
        })
        .finally(() => {
          this.bulk_linking = false;
        });
    },
    replaceRowsWithLinks(profile_competences) {
      // Cada fila pasa a ser el vínculo guardado, como al abrir la pestaña
      profile_competences.forEach((profile_competence) => {
        const index = this.profile_competences_list.findIndex(
          (row) => row.egress_profile == profile_competence.egress_profile
        );
        this.$set(profile_competence, "selected", true);
        this.persistValues(profile_competence);
        if (index != -1)
          this.profile_competences_list.splice(index, 1, profile_competence);
      });
      this.slotProfilesSelectionChanged();
    },
    slotSelectionChanged(value, row) {
      // Al seleccionar un perfil nuevo (fila con id temporal) en el modo "asociar",
      // recalcular el orden para ubicar la competencia al final del ciclo destino.
      if (value) this.updateOrderForRow(row);
      else this.slotProfilesSelectionChanged();
    },
    slotCycleUpdated(cycle_id, egress_profile_competence_id) {
      const row = this.profile_competences_list.find(
        (x) => x.id == egress_profile_competence_id
      );
      if (!row) return;
      row.cycle = cycle_id;
      // Si el usuario cambió el ciclo de una fila seleccionada aún no guardada,
      // recalcular el orden para el nuevo ciclo destino.
      if (row.selected) this.updateOrderForRow(row);
      // Se llama el siguiente metodo para que el componente padre se entere que algo cambio.
      else this.slotProfilesSelectionChanged();
    },
    updateOrderForRow(row) {
      // Solo aplica al modo "asociar" (sin perfil fijo) y a filas nuevas (id temporal).
      // Para filas ya guardadas se respeta su orden actual.
      if (!isNaN(this.egress_profile_id) || !isNaN(row.id)) {
        this.slotProfilesSelectionChanged();
        return;
      }
      // Pedir las competencias del perfil destino para conocer el último orden de su ciclo.
      // silent: en segundo plano, sin overlay de carga global, para no interrumpir el modal.
      this.$store
        .dispatch(names.FETCH_PROFILE_COMPETENCES, {
          egress_profile_id: row.egress_profile,
          silent: true,
        })
        .then((profile_competences) => {
          let max_order = 0;
          profile_competences.forEach((x) => {
            if (
              x.egress_profile == row.egress_profile &&
              x.cycle == row.cycle &&
              x.competence != row.competence &&
              x.order > max_order
            ) {
              max_order = x.order;
            }
          });
          row.order = max_order + 1;
          this.slotProfilesSelectionChanged();
        });
    },
  },
  created() {
    this.fetchEgressprofileCompetences();
    this.$store.dispatch(names.FETCH_CYCLES);
  },
  mounted() {
    this.slotProfilesSelectionChanged();
  },
};
</script>

<style scoped>
.search-competence {
  margin-bottom: 0.8em !important;
}
.form-control.is-valid,
.form-control.is-invalid {
  padding-right: calc(0.9em + 0.75rem);
  background-position: right calc(0.1em + 0.1875rem) center;
}
@media (max-width: 991px) {
  .form-control.is-valid,
  .form-control.is-invalid {
    padding-right: calc(0.1em + 0.2rem);
    background: none;
  }
}
</style>